/**
 * Inventory module — Excel export.
 *
 * Was a hand-rolled HTML-table-as-.xls trick (duplicated across Inventory/Assets/Procurement/
 * Requisitions). Consolidated 2026-07-13 to the shared, letterheaded xlsx exporter so this
 * module's reports carry the same logo/company header as everywhere else in the app. Kept the
 * same function name/signature so call sites didn't need to change — only now it's async
 * (fetches the logo, builds a real .xlsx) and downloads a .xlsx instead of a .xls.
 */
import { exportToXlsx, type ExportRow } from "#/lib/xlsxExport";

export type { ExportRow };

export function downloadXls(filename: string, title: string, headers: string[], rows: ExportRow[]): Promise<void> {
  return exportToXlsx({ filename, title, headers, rows });
}
